import { apiClient } from '@/api/client';

export interface ScanFilters {
  date_from?: string;
  date_to?: string;
}
export interface ScanSummaryMetrics {
  total_inspections: number;
  with_detections: number;
  total_detections: number;
  reviewed_inspections: number;
}
export interface ScanTrendPoint {
  bucket: string;
  total_inspections: number;
  with_detections: number;
  total_detections: number;
}
export interface ModelBreakdown {
  model_version: string | null;
  total_inspections: number;
  with_detections: number;
  total_detections: number;
}
export interface CorrectionBreakdown {
  group_id: string;
  group: string;
  category_id: string;
  category: string;
  count: number;
}

export interface CorrectionProgressCategory {
  group: string;
  category_id: string;
  code: string;
  category: string;
  count: number;
}
export interface CorrectionProgress {
  target: number;
  categories: CorrectionProgressCategory[];
}

export async function getSummary(filters: ScanFilters) {
  const { data } = await apiClient.get<ScanSummaryMetrics>('/scan-analytics/summary', {
    params: filters,
  });
  return data;
}
export async function getTrend(filters: ScanFilters, granularity: 'day' | 'week' = 'day') {
  const { data } = await apiClient.get<ScanTrendPoint[]>('/scan-analytics/trend', {
    params: { ...filters, granularity },
  });
  return data;
}
export async function getByModel(filters: ScanFilters) {
  const { data } = await apiClient.get<ModelBreakdown[]>('/scan-analytics/by-model', {
    params: filters,
  });
  return data;
}
export async function getCorrectionProgress(filters: ScanFilters) {
  const { data } = await apiClient.get<CorrectionProgress>('/scan-analytics/correction-progress', {
    params: filters,
  });
  return data;
}
export async function getCorrections(filters: ScanFilters) {
  const { data } = await apiClient.get<CorrectionBreakdown[]>('/scan-analytics/corrections', {
    params: filters,
  });
  return data;
}
